export default __webpack_public_path__ + "static/olakunbi-odu-84db5233ec896b858bd36431f475e84c.png";